<template>
  <v-container fluid class="page-wrap">
    <v-row>
      <v-col cols="12" class="text-center">
        <header-vue />
      </v-col>

      <v-col class="mb-5" md="12">
        <v-card class="rounded-xl pa-2 pa-md-3" elevation="3">
          <v-card-title class="page-title-row">
            <div>
              <div class="text-overline accent--text font-weight-bold">TOKENS</div>
              <div class="text-h6 font-weight-bold primary--text">Token Usage History</div>
              <div class="text-body-2 grey--text">See all the tokens you have used so far & what you used it for</div>
            </div>
          </v-card-title>
          <v-card-text>
            <div class="d-flex flex-wrap dashboard-links mb-4">
              <a class="link" @click="buyTokenModal = !buyTokenModal">
                <v-icon small left color="primary">mdi-shopping-outline</v-icon>
                Get More Tokens
              </a>
              <router-link class="link" :to="{name: 'ModuleSelector'}">
                <v-icon small left color="primary">mdi-view-dashboard-outline</v-icon>
                Back to Dashboard
              </router-link>
            </div>

            <v-row>
              <v-col cols="12">
                <v-card outlined class="rounded-lg">
                  <v-data-table
                    :headers="headers"
                    :items="tokenUsage"
                    :loading="loading"
                    class="elevation-0"
                    loading-text="Loading token usage history..."
                    disable-sort
                    dense
                  >
                    <template v-slot:item.created_at="{ item }">
                      {{ formatDate(item.created_at) }}
                    </template>
                    <template v-slot:no-data>
                      <v-alert type="info" text class="ma-4">No token usage history found.</v-alert>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <buy-token-modal v-if="buyTokenModal"/>
    </v-row>
  </v-container>
</template>

<script>
import HeaderVue from '../components/Header.vue'
import BuyTokenModal from '../components/BuyTokenModal.vue';
export default {
    components: {
        HeaderVue,
        BuyTokenModal
    },
    data() {
        return {
            headers: [
                { text: 'Description', value: 'description' },
                { text: 'Token Used', value: 'tokens' },
                { text: 'Date Used', value: 'created_at' }
            ],
            tokenUsage: [],
            loading: false,
            school: localStorage.getItem('school') ? JSON.parse(localStorage.getItem('school')) : null,
            authToken:sessionStorage.getItem('authToken') ?? null,
            buyTokenModal: false,
        };
    },
  methods: {
    async fetchTokenUsage() {
        this.loading = true;
        try {
            const response = await fetch(process.env.VUE_APP_BASEURL+'/tokens-usage?school_id='+this.school.school_id, {
                headers:
                    {
                        'Authorization': 'Bearer '+this.authToken
                    }
            }); // Replace with your actual API
            const data = await response.json();
            this.tokenUsage = data.data;
        } catch (error) {
            console.error('Failed to fetch token usage history:', error);
        } finally {
            this.loading = false;
        }
    },
    formatDate(dateStr) {
        const options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        };
        return new Date(dateStr).toLocaleString(undefined, options);
    }

  },
  mounted() {
        this.fetchTokenUsage();
  }
};
</script>
<style scoped>
.dashboard-links {
    gap: 24px;
}
.link{
    text-decoration: none;
    font-weight: 600;
    font-size: 0.85rem;
    color: #1E3C72;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
}
</style>
